/**
 * Shared v1 envelope validation — SPA architectural convergence plan §6.1.
 *
 * `fetch-sse.ts`, `category-reducers.ts`, and `v1-zenoh-client.ts` each
 * need to reject a payload whose `schema_version` they don't
 * understand (plan: "The SPA refuses to render a payload whose
 * schema_version it does not understand."). This was previously
 * three separate inline checks; centralising it here means the three
 * modules can never silently drift apart on what counts as valid.
 */
import type { V1Envelope } from './v1';

export const SUPPORTED_SCHEMA_VERSION = '1.0' as const;

export function isValidEnvelope(envelope: V1Envelope | null | undefined): envelope is V1Envelope {
  return !!envelope && envelope.schema_version === SUPPORTED_SCHEMA_VERSION;
}
